<script>

export default {
  data() {
    return {
      urlImage: '',
      image: '',
    }
  },
  mounted() {

  },
  methods: {
    changeImg({coordinates, canvas}) {
      if(this.image) { this.$emit('updateimg', canvas.toDataURL()); } else { this.$emit('updateimg',''); }
    },
    handleUpload(e) {
      var tempImage = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (a) => { this.image = a.target.result; };
      reader.onerror = error => { alert(error); };
      reader.readAsDataURL(tempImage);
    },
    handleImageURL() {
      console.log(this.app_url+'/ext?url='+this.urlImage);
      this.image = this.app_url+'/ext?url='+this.urlImage;
    },
    clearImage() {
      this.image = '';
      if(this.image) { this.$emit('updateimg', canvas.toDataURL()); } else { this.$emit('updateimg',''); }
    },
  }
}
</script>

<template>
  <div>

    <div v-if="!image">
      <div class="mb-3">
        <label for="">Upload from device :</label>
        <div class="">
          <button type="button" class="btn btn-block btn-success" @click="$refs.imageInput.click()"><Icon icon="ri:upload-cloud-line"></Icon> Upload image</button>
          <input ref="imageInput" type="file" accept="image/*" @change="handleUpload" class="form-control d-none">
        </div>
      </div>
      <div class="mb-5">
        <label for="" v-tippy content="This method does not work most of the time due to cross domain restrictions.">Add image by URL : <Icon icon="ri:information-fill" class="text-muted" /></label>
        <div class="input-group">
          <input type="text" class="form-control" v-model="urlImage">
          <div class="input-group-append">
            <button type="button" class="btn btn-success" @click="handleImageURL"><Icon icon="ri:add-line"></Icon> Add</button>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="mb-3">
        <label for="">Image preview/cropper :</label>
        <cropper ref="cropper" style="min-height:200px;" :resize-image="false" class="cropper border" :src="image" :stencil-props="{aspectRatio: 10/10}" @change="changeImg"></cropper>
      </div>
      <div class="mb-5">
        <button type="button" class="btn btn-block btn-white" @click="clearImage">Clear image</button>
      </div>
    </div>

  </div>
</template>
